import { useAppSelector } from '~/store/reduxHooks';
import { selectIsMergeModified, selectWorkflowOperationDescs } from 'flow/store/redux/selectors';
import InfoToolbar from './InfoToolbar';
import { useContext, useMemo } from 'react';
import { findLastOperation } from 'flow/service/assistance';
import { RuleBuilderContext } from '../context';
import { OperationMessageType } from 'flow/store/engine/types';
import { isEditable } from '../helpers';
import { ContainerType } from '../../types';
import AssistanceToolbar from './AssistanceToolbar';

const RuleBuilderToolbar = () => {
  const { containerType, editMode, sourceAction } = useContext(RuleBuilderContext);
  const isMergeModified = useAppSelector(selectIsMergeModified(sourceAction.publicId));
  const operationDescriptions = useAppSelector(selectWorkflowOperationDescs);

  const isDrawerOrIsland = [ContainerType.DRAWER, ContainerType.ISLAND]
    .includes(containerType);

  const relevantEngineAssistanceData = useMemo(
    () => findLastOperation({
      operations: operationDescriptions,
      publicId: sourceAction.publicId,
      types: [
        OperationMessageType.actionRuleThreshold,
        OperationMessageType.undo,
      ],
    }),
    [operationDescriptions, sourceAction]);

  if (isMergeModified && isDrawerOrIsland) {
    return <InfoToolbar />;
  }

  if (
    relevantEngineAssistanceData
      && isEditable(editMode)
      && isDrawerOrIsland
  ) {
    return (
      <AssistanceToolbar
        assistanceMessageObject={relevantEngineAssistanceData}
      />
    );
  }

  return null;
};

export default RuleBuilderToolbar;
